export default __webpack_public_path__ + "static/media/denys.1b33975a.jpg";